import React, { Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import "./App.scss";
import ScrollToTop from "../utils/ScrollToTop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import MeetPage from "../pages/MeetPage/MeetPage";

import { MeetPage_Dr } from "../pages/MeetPage_Dr/MeetPage_Dr";
import { MeetPage_Pt } from "../pages/MeetPage_Pt/MeetPage_Pt";
import { JoinConsultation } from "../pages/JoinConsultation/JoinConsultation";
import Homepage from "./HomePage/Homepage";
import FaqContent from "./FAQ/FaqContent";
import Faq from "./FAQ/Faq";
import "slick-carousel/slick/slick.css";
import "antd/dist/antd.min.css";
import "slick-carousel/slick/slick-theme.css";
import "@culturehq/add-to-calendar/dist/styles.css";
import PageLoader from "./PageLoader/PageLoader";

const Login = React.lazy(() => import("../pages/login"));
const SpecialityPage = React.lazy(() => import("../pages/SpecialityListing"));
const SignupPage = React.lazy(() => import("../pages/Signup"));
const DoctorProfileSchedulePage = React.lazy(() =>
  import("../pages/DoctorProfileSchedule")
);
const MicrositePage = React.lazy(() => import("../pages/Microsite"));
const HowToDoConsultationpage = React.lazy(() => import("../pages/HowToDoConsultation"));
const ContactUsPage = React.lazy(() => import("../pages/ContactUs"));
const TreatmentPage = React.lazy(() => import("../pages/Treatment"));
const OurDoctorPage = React.lazy(() => import("../pages/OurDoctor"));
const VerificationCodePage = React.lazy(() => import("../pages/Verification"));
const SigninPage = React.lazy(() => import("../pages/Signin"));
const LoginPage = React.lazy(() => import("../pages/login"));
const ResetPasswordPage = React.lazy(() => import("../pages/ResetPassword"));
const Addnumberpage = React.lazy(() => import("../pages/Addnumber"));
const GustLoginPage = React.lazy(() => import("../pages/Gustlogin"));
const ConfirmPasswordPage = React.lazy(() =>
  import("../pages/ConfirmPassword")
);

const PasswordChangePage = React.lazy(() => import("../pages/PasswordChange"));
const DoctorListingPage = React.lazy(() => import("../pages/DoctorListing"));
const BookAppointmentPage = React.lazy(() =>
  import("../pages/BookAppointment")
);
const AboutUsPage = React.lazy(() => import("../pages/AboutUs"));

const MobileDashboardPage = React.lazy(() =>
  import("../pages/MobileDashboard")
);

const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard"));

// const DoctorDashboard = React.lazy(() =>
//   import("../components/DoctorDashboard/DoctorDashboard")
// );

// const Spinner = React.lazy(() => import('react-bootstrap/Spinner'));
const TermsandConditions = React.lazy(() =>
  import("../pages/TermsandConditions")
);
const ForDoctorPage = React.lazy(() => import("../pages/ForDoctor"));
const AdminHome = React.lazy(() =>
  import("../pages/InterbranchAdmin/InterbranchAdminHome")
);
const PrescriptionPolicyPage = React.lazy(() =>
  import("../pages/PrescriptionPolicy")
);

const ForPatient = React.lazy(() => import("../pages/Forpatients"));
const PartnerPage = React.lazy(() => import("../pages/PartnerPage"));
const PrescriptionCrPage = React.lazy(() =>
  import("../pages/PriscriptionCr/Index")
);

const ResetPasswordBridge = React.lazy(() =>
  import("../pages/ResetPasswordBridge/ResetPasswordBridge")
);
const Interbranch = React.lazy(() =>
  import("../components/InterBranchCoordinator/index")
);
const ConsultationScreenPatient = React.lazy(() =>
  import("../pages/ConsultationScreen/patient/index")
);
const ConsultationScreenDoctor = React.lazy(() =>
  import("../pages/ConsultationScreen/doctor/index")
);

const RequestUrlValidation = React.lazy(() =>
  import("../components/RequestURLValidation/Index")
);

// const ConsultationScreenPatientZoom = React.lazy(() =>
//   import("../pages/ConsultationScreen/patientConnectZoom")
// );
// const ConsultationScreenDoctorZoom = React.lazy(() =>
//   import("../pages/ConsultationScreen/ZoomConnect")
// );

const ConsultationScreenPatientZoom = React.lazy(() =>
  import("../pages/ConsultationScreen/ZoomPatientUI")
);
const ConsultationScreenDoctorZoom = React.lazy(() =>
  import("../pages/ConsultationScreen/ZoomDoctorUI")
);

/*const ConsultationScreenDoctorZoom = React.lazy(() =>
  import("../pages/ConsultationScreen/UIkitSample")
);
*/



// const MultipartyConsultation = React.lazy(() => import("../pages/ConsultationScreen/MultipartyConsultation"));
const C2mdHome = React.lazy(() => import("../pages/HomePage/Homepage"));
const MeetHome = React.lazy(() => import("../pages/Meet Home/MeetHome"));
const ProductsPage = React.lazy(() =>
  import("../pages/ProductsPage/ProductsPage")
);
const RpmHome = React.lazy(() => import("../pages/Meet Home/Rpm"));
const OminiromHome = React.lazy(() => import("../pages/Meet Home/OminiRom"));
const CAReHome = React.lazy(() => import("../pages/Meet Home/CARe"));
const HomeDoc = React.lazy(() => import("../pages/Meet Home/HomeDoc"));
const contactPage = React.lazy(() =>
  import("../pages/ContactUsPage/ContactUs")
);
const DownloadPrescription = React.lazy(() =>
  import("./DownloadPrescription/DownloadPrescription")
);
const MediaPage = React.lazy(() => import("../pages/MediaPage/MediaPage"));
const IntegratedAppsPage = React.lazy(() =>
  import("../pages/IntegratedApps/IntegratedApps")
);
const PrintPrescription = React.lazy(() =>
  import("../components/PrintPrescription/PrintPrescription")
);
const UosLandingPage = React.lazy(() =>
  import("../pages/UosLandingPage/UosLandingPage")
);
const ReemDashboard = React.lazy(() =>
  import("../pages/ReemDashboard/ReemDashboard")
);
const DepartmentProfile = React.lazy(() =>
  import("../pages/DepartmentProfile/DepartmentProfile")
);
const GangahospitalPage = React.lazy(() => import("../pages/Ganagahospitals"));
const TestPage = React.lazy(() => import("../pages/TestingPage/TestingPage"));
const ContactUsForBusiness = React.lazy(() =>
  import(
    "../pages/ContactUsPages/ConytactUsForBusiness/ContactUsForBusinessPage"
  )
);

const DyetConnect = React.lazy(() =>
  import("../pages/ConsultationScreen/DyetConnect")
);
const ConsultationScreenDoctorDyte = React.lazy(() =>
  import("../pages/ConsultationScreen/DyteUIConnect")
);

const GangaMobileApp = React.lazy(() =>
  import("../pages/GangaMobileApp/GangaMobileApp")
);

const BrowserSupport = React.lazy(() =>
  import("../pages/BrowserSupport/BrowserSupport")
);
const PatientConsultationScreenResponsive = React.lazy(() =>
  import("../pages/ConsultationScreen/ZoomPatientUI")
);

function App() {
  function getFaviconEl() {
    return document.getElementById("favicon");
  }
  

  const isMobile = useMediaQuery({ maxWidth: 1024 }); // Adjust the breakpoint as needed

  const favicon = getFaviconEl();
  console.log('favicon', favicon)
  console.log("isMobile", isMobile);
  // console.log = function () {};
  console.log("window?.crossOriginIsolated",window?.crossOriginIsolated)

  function DesktopComponents() 
  {
    var isSafari = window.safari !== undefined
    //var isSafari =false
   var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    //var isFirefox =false

    console.log("isSafari", isSafari);
    return(
      <Switch>
              <Route exact path="/" component={GangahospitalPage} />

              <Route exact path="/mobile-app" component={GangaMobileApp} />

              {/* <Route exact path="/loader" component={PageLoader} /> */}
              <Route exact path="/speciality" component={SpecialityPage} />
              <Route
                exact
                path="/aravindhospitals"
                component={GangahospitalPage}
              />
              <Route exact path="/DoctorListing" component={SpecialityPage} />
              <Route
                exact
                path="/doctorProfile/:doctorid"
                component={DoctorProfileSchedulePage}
              />
              <Route exact path="/signup" component={SignupPage} />
              <Route
                exact
                path="/signup/verify"
                component={VerificationCodePage}
              />
              <Route exact path="/signup/addnumber" component={Addnumberpage} />

              <Route exact path="/admin" component={AdminHome} />
              <Route exact path="/gustlogin" component={GustLoginPage} />
              
              {/* Adding the prescription route ---- to move to prescription after call end from dr */}
              {/* <Route
                exact
                path="/admindashboard"
                component={PrescriptionCrPage}
              /> */}
              <Route path="/interbranch" component={Interbranch} />
              <Route path="/corporate" component={ProductsPage} />
              <Route path="/contactus" component={contactPage} />
              <Route path="/for-patients/contactus" component={contactPage} />
              <Route path="/corporate/contactus" component={contactPage} />
              <Route path="/AboutUs/contactus" component={contactPage} />
              <Route path="/uos" component={UosLandingPage} />
              <Route path="/reem" component={ReemDashboard} />
              <Route
                path="/departmentprofile/:speciality"
                component={DepartmentProfile}
              />
              <Route path="/partner-with-us" component={PartnerPage} />
              <Route path="/forpatients" component={ForPatient} />
              <Route
                path="/termsofUse/:typeId"
                component={TermsandConditions}
              />
              <Route path="/termsofUse" component={TermsandConditions} />
              <Route path="/signin" component={SigninPage} />
              <Route path="/login" component={SigninPage} />
              <Route path="/reset" component={ResetPasswordPage} />
              <Route path="/products" component={ProductsPage} />
              <Route
                path="/downloadPrescription"
                component={DownloadPrescription}
              />
              <Route
                path="/prescription/:appointmentId"
                component={PrintPrescription}
              />
              <Route path="/test" component={ContactUsForBusiness} />

              <Route path="/dashboard" component={Dashboard} />
              {/* <Route path="/dashboard" component={DoctorDashboard} /> */}
              <Route path="/videcall" component={MeetHome} />
              <Route path="/rpm" component={RpmHome} />
              <Route path="/ominirom" component={OminiromHome} />
              <Route path="/care" component={CAReHome} />
              <Route path="/homedoc" component={HomeDoc} />

              <Route path="/meet" component={MeetPage} />

              <Route path="/faq" component={Faq} />
              <Route exact path="/rb/:key" component={RequestUrlValidation} />

              {/* <Route
                path="/meetdr/:appointmentId"
                component={DyetConnect}
              /> 
                 <Route
                path="/meetpatient/:appointmentId"
                component={DyetConnect}
              /> */}
              
          {/* <Route
                path="/meetdr/:appointmentId"
                component={ConsultationScreenDoctor}
              /> 

              <Route
                path="/meetpatient/:appointmentId"
                component={ConsultationScreenPatient}
              />   */}
              
                <Route
                path="/meetdr/:appointmentId"
                component={!isSafari && !isFirefox? ConsultationScreenDoctorZoom:BrowserSupport}
              />
              <Route
                path="/meetpatient/:appointmentId"
                component={!isSafari && !isFirefox? isMobile ? PatientConsultationScreenResponsive:ConsultationScreenPatientZoom:BrowserSupport}
              /> 
             
              <Route
                path="/joinconsultation/:appointmentId"
                component={ConsultationScreenPatientZoom}
              />
              {/* <Route path="/multipartyconsult" component={MultipartyConsultation} /> */}
              <Route path="/media" component={MediaPage} />
              <Route path="/integrated-apps" component={IntegratedAppsPage} />
              <Route
                exact
                path="/prescriptionpolicy"
                component={PrescriptionPolicyPage}
              />
              <Route
                exact
                path="/resetpassword"
                component={ConfirmPasswordPage}
              />

              <Route
                exact
                path="/patientmail/:key"
                component={ResetPasswordBridge}
              />
              <Route
                exact
                path="/doctormail/:key"
                component={ResetPasswordBridge}
              />

              <Route
                exact
                path="/confirmpassword"
                component={ConfirmPasswordPage}
              />
              <Route
                exact
                path="/passwordchange"
                component={PasswordChangePage}
              />
              <Route
                exact
                path="/DoctorListing"
                component={DoctorListingPage}
              />
              <Route
                exact
                path="/DoctorListing/:clinicId"
                component={GangahospitalPage}
              />
              <Route
                exact
                path="/DoctorListing/:clinicId/:speciality"
                component={GangahospitalPage}
              />
              <Route
                exact
                path="/BookAppointment/:doctorId"
                component={BookAppointmentPage}
              />
              <Route exact path="/Aboutus" component={AboutUsPage} />
              <Route exact path="/:clinicId" component={DoctorListingPage} />
              <Route path='/testcomputer' component={() => {
                window.location.href = '/qualitychecker.html';
                return null;
            }}/>
              {/* <Route exact path="/mircrosite/:clinicId" component={OurDoctorPage}/> */}
              <Route
                exact
                path="/:clinicId/howitworks"
                component={MicrositePage}
              />
              <Route
                exact
                path="/:clinicId/prepareforconsultation"
                component={HowToDoConsultationpage}
              />
              <Route
                exact
                path="/prepareforconsultation"
                component={HowToDoConsultationpage}
              />
              <Route
                exact
                path="/:clinicId/contactus"
                component={ContactUsPage}
              />
              <Route
                exact
                path="/:clinicId/treatment"
                component={TreatmentPage}
              />
              <Route
                exact
                path="/:clinicId/ourdoctor"
                component={OurDoctorPage}
              />
              <Route
                exact
                path="/:clinicId/ourdoctor/:speciality"
                component={OurDoctorPage}
              />
              <Route
                exact
                path="/:clinicId/DoctorListing"
                component={GangahospitalPage}
              />
              {/* <Route exact path="/:clinicId" component={DoctorListingPage} /> */}
              <Route
                exact
                path="/:clinicId/:speciality"
                component={DoctorListingPage}
              />

              {/* <Route path="/termsofUse" component={TermsandConditions} /> */}
            </Switch>
    )
  }
  return (
    <>
      {/* <Router basename={'/ROOT/'}> */}
      <Router basename={"/aravind/"}>
        <div>
        
      
          {/* <Suspense fallback={<></>}> */}
          <Suspense fallback={<PageLoader />}>
            <ScrollToTop />
            <ToastContainer style={{ zIndex: 20000 }} limit={1} />
            {isMobile ? (
           //<GangaMobileApp />
          <DesktopComponents />
        ) : (
          
          <DesktopComponents />
        )}
          </Suspense>
         
        </div>
      </Router>
    </>
  );
}

export default App;
